/**
 * Per-update destination overrides for the campaign update modal's
 * "View Opportunity" CTA.
 *
 * Map keys are `OfferingUpdate.id` values (case-insensitive); values must
 * be site-relative paths under `/offering/` and are validated against that
 * allow-list before being returned to callers. Anything else resolves to
 * `null` so the caller falls back to default behaviour (close the modal).
 *
 * Keep this map small. If it grows past a handful of entries, add a
 * `redirectOfferingSlug` field to `OfferingUpdate` in `startengine-campaign`
 * and read it on the FE instead of maintaining hardcoded overrides.
 */
const VIEW_OPPORTUNITY_OVERRIDES = Object.freeze({
  '90bda420-f339-4808-a967-b175ddd42e6e': '/offering/greenfield-robotics',
});

const ALLOWED_PATH_PREFIX = '/offering/';

const isSafeOverrideUrl = (value) =>
  typeof value === 'string' && value.startsWith(ALLOWED_PATH_PREFIX) && !value.startsWith('//');

/**
 * Returns the override URL for a given update id, or `null` when no override
 * applies or when the configured override fails the safety check.
 *
 * @param {string | null | undefined} updateId
 * @returns {string | null}
 */
export function getViewOpportunityOverride(updateId) {
  if (!updateId || typeof updateId !== 'string') return null;
  const override = VIEW_OPPORTUNITY_OVERRIDES[updateId.toLowerCase()];
  if (!isSafeOverrideUrl(override)) return null;
  return override;
}

export const __TEST_ONLY__ = {
  VIEW_OPPORTUNITY_OVERRIDES,
  isSafeOverrideUrl,
};
